"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.search");
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _moment = _interopRequireDefault(require("moment"));
var _returnDetail = _interopRequireDefault(require("@/components/wareHouse/returnDetail.vue"));
var _returnInWare = _interopRequireDefault(require("@/components/wareHouse/returnInWare.vue"));
var _warehouse = require("@/api/warehouse");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    ReturnDetail: _returnDetail.default,
    ReturnInWare: _returnInWare.default
  },
  data: function data() {
    return {
      search: {
        borrowDate: '',
        retDate: '',
        warehouseId: '',
        //仓库id
        locationId: '',
        //库位id
        billNo: '',
        retStatus: ''
      },
      list: [],
      wareList: [],
      LocationList: [],
      statusList: [{
        id: 0,
        name: '未归还'
      }, {
        id: 1,
        name: '已归还'
      }, {
        id: 2,
        name: '部分归还'
      }],
      listLoading: true,
      info: {},
      total: 0,
      pageNo: 1,
      pageSize: 10
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getList();
    this.getHouse();
  },
  methods: {
    onClear: function onClear() {
      this.search = {
        // borrowDate: '',
        // retDate: '',
        // warehouseId: '', //仓库id
        // locationId: '', //库位id
        // billNo: '',
        // retStatus: ''
      };
      this.pageNo = 1;
      this.getList();
    },
    updateList: function updateList(val) {
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.search), {}, {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });
      (0, _warehouse.listReturnApi)(params).then(function (data) {
        var res = data.data;
        if (res.errno == 0) {
          _this.listLoading = false;
          _this.list = res.data.data.list;
          _this.total = res.data.data.total;
        }
      });
    },
    // 仓库列表
    getHouse: function getHouse() {
      var _this2 = this;
      (0, _warehouse.warehouseListApi)({}).then(function (data) {
        var res = data.data;
        if (res.errno == 0) {
          _this2.wareList = res.data;
        }
      });
    },
    selectWare: function selectWare(val) {
      this.getListLocation(val);
    },
    // 库位列表
    getListLocation: function getListLocation(val) {
      var _this3 = this;
      var params = {
        warehouseId: val
      };
      (0, _warehouse.listLocationListApi)(params).then(function (data) {
        var res = data.data;
        if (res.errno == 0) {
          _this3.LocationList = res.data;
        }
      });
    },
    // 记录查询
    recordSearch: function recordSearch() {
      this.$router.push('/wareHouse/recordQuery');
    },
    // 查找
    onSearch: function onSearch() {
      this.pageNo = 1;
      this.getList();
    },
    // 仓库详情
    getDetail: function () {
      var _getDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(id) {
        var data, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _warehouse.listBillDetailApi)({
                inoutId: id
              });
            case 1:
              data = _context.v;
              res = data.data;
              if (res.errno == 0) {
                this.info = res.data;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getDetail(_x) {
        return _getDetail.apply(this, arguments);
      }
      return getDetail;
    }(),
    // 查看详情
    toDetail: function () {
      var _toDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(item) {
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.getDetail(item.inoutId);
            case 1:
              this.$refs.ReturnDetail.open(this.info);
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function toDetail(_x2) {
        return _toDetail.apply(this, arguments);
      }
      return toDetail;
    }(),
    // 归还入库
    toReturn: function () {
      var _toReturn = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(item) {
        var _this4 = this;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(item.retStatus == 1)) {
                _context3.n = 1;
                break;
              }
              this.$confirm('是否要进行删除操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(function () {
                var params = {
                  inoutId: item.inoutId
                };
                (0, _warehouse.deleteRetApi)(params).then(function (res) {
                  console.log(res);
                  if (res.data.errno == 0) {
                    _this4.$message.success('删除成功');
                    _this4.getList();
                  } else {
                    _this4.$message.warning(res.data.msg);
                  }
                });
              }).catch(function () {
                _this4.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
              _context3.n = 3;
              break;
            case 1:
              _context3.n = 2;
              return this.getDetail(item.inoutId);
            case 2:
              this.$refs.ReturnInWare.open(this.info, item.inoutId);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function toReturn(_x3) {
        return _toReturn.apply(this, arguments);
      }
      return toReturn;
    }(),
    // 日期和状态比较 部分归还和未归还到期后都需要高亮显示
    isHighlight: function isHighlight(row) {
      var date = (0, _moment.default)();
      if (date.isAfter((0, _moment.default)(row.retDate).format('YYYY-MM-DD'), 'day') && row.retStatus !== 1) return true;else return false;
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
        rowIndex = _ref.rowIndex;
      return this.isHighlight(row) ? 'highlight' : '';
    }
  }
};